import React from 'react';
import { Link } from 'react-router-dom';

import { useAppContext } from '@prisjakt/ui-app-context';

import * as S from './styles';

type Props = {
  avatar: React.ReactElement;
  displayName?: string;
  userReviewCount?: number | null;
  id?: string | null;
};

const User = ({ avatar, displayName, userReviewCount = 0, id }: Props) => {
  const { t } = useAppContext();

  return (
    <S.User>
      <Link to={`/user/${id}`}>
        <S.UserAvatar>{avatar}</S.UserAvatar>
      </Link>
      <Link to={`/user/${id}`}>
        <S.UserInfo>
          <S.UsernameLabel>{displayName}</S.UsernameLabel>
          {userReviewCount && userReviewCount > 0 && (
            <S.ReviewCountLabel>
              {t('reviews', 'user.total-reviews', {
                n: userReviewCount,
              })}
            </S.ReviewCountLabel>
          )}
        </S.UserInfo>
      </Link>
    </S.User>
  );
};

export default User;
